module.exports = __webpack_public_path__ + "media/images/checkbox-checked-c0def9de3e255b4ad68ece389c0601ed.svg";